import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HelperMessage } from '@atlaskit/form';
import { Text } from '@atlaskit/primitives/compiled';
import { N200 } from '@atlaskit/theme/colors';
export const QuestionHelperMsg = ({
  description
}) => {
  return !!description ? /*#__PURE__*/React.createElement(HelperMessageWrapper, null, /*#__PURE__*/React.createElement(HelperMessage, null, /*#__PURE__*/React.createElement(Text, {
    testId: "description"
  }, description))) : null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HelperMessageWrapper = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  span: {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginBottom: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtlest, ${N200})`
  }
});